import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { FiltersTable } from 'components/FiltersTable';

export function Filters() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <TablePageLayout
      title="Фильтры"
      actionContent={
        <Button
          sx={{ ml: 5 }}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            tableRef.current?.openFormDialog();
          }}
        >
          Добавить фильтр
        </Button>
      }
    >
      <FiltersTable
        id="filters-table"
        ref={tableRef}
        automaticallyOpenEditPage={false}
        searchFilter={{
          inputProps: {
            placeholder: 'Поиск по названию',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              { title: { _ilike: `%${str}%` } },
              { subtitle: { _ilike: `%${str}%` } },
            ]),
          }),
        }}
      />
    </TablePageLayout>
  );
}
